import { render, staticRenderFns } from "./MsgScroll.vue?vue&type=template&id=7ac12d3d&scoped=true&"
import script from "./MsgScroll.vue?vue&type=script&lang=js&"
export * from "./MsgScroll.vue?vue&type=script&lang=js&"
import style0 from "./MsgScroll.vue?vue&type=style&index=0&id=7ac12d3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac12d3d",
  null
  
)

export default component.exports